module.exports = __webpack_public_path__ + "img/consulting.b7904fdc.jpg";